export type { BiometricType } from '../../../../../../auth/nocode/types';

export const BIOMETRIC_EVENT_PREFIX = '__ua_biometric_';
export enum BiometricMessageTypes {
  ENROLL = '__ua_biometric_enroll',
  REVOKE = '__ua_biometric_revoke',
  VERIFY = '__ua_biometric_verify',
  INFO = '__ua_biometric_info',
  ENROLL_SUCCESS = '__ua_biometric_enroll_success',
  REVOKE_SUCCESS = '__ua_biometric_revoke_success',
  VERIFY_SUCCESS = '__ua_biometric_verify_success',
}
